import { exeRequest } from '../utils/APIUtils';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // Récupérer tous les rôles
  getAll: async (includeInactive = false) => {
    const query = includeInactive ? '?includeInactive=true' : '';
    return exeRequest(`/admin/roles${query}`, 'GET');
  },

  // Récupérer les rôles pour le sélecteur (version simplifiée)
  getForSelect: async () => {
    return exeRequest('/admin/roles/select', 'GET');
  },

  // Récupérer un rôle par ID
  getById: async (id) => {
    return exeRequest(`/admin/roles/${id}`, 'GET');
  },

  // Créer un nouveau rôle
  create: async (data) => {
    return exeRequest('/admin/roles', 'POST', data);
  },

  // Mettre à jour un rôle
  update: async (id, data) => {
    return exeRequest(`/admin/roles/${id}`, 'PUT', data);
  },

  // Supprimer un rôle
  delete: async (id) => {
    return exeRequest(`/admin/roles/${id}`, 'DELETE');
  },

  // Activer/Désactiver un rôle
  toggle: async (id) => {
    return exeRequest(`/admin/roles/${id}/toggle`, 'PATCH');
  },

  // Récupérer les permissions disponibles
  getPermissions: async () => {
    return exeRequest('/admin/roles/permissions', 'GET');
  },
};
